import { render } from "./TicketsView.vue?vue&type=template&id=f22eda82&scoped=true"
import script from "./TicketsView.vue?vue&type=script&lang=js"
export * from "./TicketsView.vue?vue&type=script&lang=js"

import "./TicketsView.vue?vue&type=style&index=0&id=f22eda82&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f22eda82"]])

export default __exports__